<template>
  <div class="nv-page">
    <div class="nv-card">
      <div class="nv-section-head">
        <div>
          <h2 class="nv-section-head__title">Firmalarım</h2>
          <p class="nv-section-head__subtitle">
            {{ CompanyInfo.length }} kayıt · Modüllerinizi görüntüleyebilir, yeni başvuru ve etiket oluşturabilirsiniz.
          </p>
        </div>
      </div>

      <v-row>
        <v-col cols="12" lg="6" v-for="(item,index) in CompanyInfo" :key="index">
          <v-expansion-panels class="nv-company">
            <v-expansion-panel>
              <v-expansion-panel-header>
                <div class="nv-company__head">
                  <span class="nv-company__icon" :class="{'is-branch': item.BranchName !== 'Merkez'}">
                    <v-icon small color="white">
                      {{ item.BranchName === 'Merkez' ? 'mdi-domain' : 'mdi-source-branch' }}
                    </v-icon>
                  </span>
                  <div class="nv-company__info">
                    <span class="nv-company__branch">{{ item.BranchName }}</span>
                    <v-tooltip bottom>
                      <template v-slot:activator="{ on, attrs }">
                        <strong v-bind="attrs" v-on="on" class="nv-company__name">
                          {{ (item.Name.length > 40) ? item.Name.substr(0, 40) + "..." : item.Name }}
                        </strong>
                      </template>
                      <span class="font-size-sm">{{ item.Name }}</span>
                    </v-tooltip>
                    <span class="nv-company__meta">
                      <span v-if="companyModules(item).length" class="nv-company__preview">
                        <v-tooltip bottom v-for="(module, previewIndex) in companyModules(item).slice(0, 6)" :key="previewIndex">
                          <template v-slot:activator="{ on, attrs }">
                            <span v-bind="attrs" v-on="on" class="nv-company__preview-icon">
                              <v-icon x-small>{{ ModulesIcon(module.Name) }}</v-icon>
                            </span>
                          </template>
                          <span class="font-size-sm">{{ module.Description }}</span>
                        </v-tooltip>
                        <span v-if="companyModules(item).length > 6" class="nv-company__preview-more">
                          +{{ companyModules(item).length - 6 }}
                        </span>
                      </span>
                      {{ companyModules(item).length ? companyModules(item).length + ' modül' : 'Modül bulunmuyor' }}
                    </span>
                  </div>
                  <div @click.stop.prevent class="nv-company__action">
                    <v-btn
                        :disabled="(Array.isArray(item.ModuleResponse) && (item.ModuleResponse.filter(x=>item.BranchName == 'Merkez' ? centerModules.includes(x.Name) : branchModules.includes(x.Name)).length == (item.BranchName == 'Merkez' ? 9 : 2)))"
                        small text class="nv-btn nv-btn--dashed" @click="createModule(item)">
                      <v-icon small left>mdi-plus</v-icon>
                      Yeni Başvuru
                    </v-btn>
                  </div>
                </div>
                <template v-slot:actions>
                  <v-icon color="primary">
                    $expand
                  </v-icon>
                </template>
              </v-expansion-panel-header>
              <v-expansion-panel-content>
                <div v-if="!Array.isArray(item.ModuleResponse) || !item.ModuleResponse.length" class="nv-empty">
                  <v-icon color="#90A1B9">mdi-package-variant</v-icon>
                  <span>Henüz tanımlı modül bulunmuyor. "Yeni Başvuru" ile modül ekleyebilirsiniz.</span>
                </div>
                <div v-else class="nv-modules">
                  <div class="nv-modules__title">Modüller</div>
                  <div class="nv-modules__grid">
                    <div class="nv-module"
                         v-for="(module,moduleIndex) in item.ModuleResponse"
                         :key="moduleIndex">
                      <span class="nv-module__icon">
                        <v-icon small>{{ ModulesIcon(module.Name) }}</v-icon>
                      </span>
                      <div class="nv-module__body">
                        <span class="nv-module__name">{{ module.Description }}</span>

                        <div class="nv-module__aliases"
                             v-if="['EInvoice','EDespatch'].includes(module.Name) && item.CompanyAliasResponse && item.CompanyAliasResponse.some(x=>x.Type === module.Name && (['GondericiBirim','PostaKutusu'].includes(x.AliasType)))">
                          <v-tooltip bottom>
                            <template v-slot:activator="{ on, attrs }">
                              <span v-if="item.CompanyAliasResponse.some(x=>x.Type === module.Name && x.AliasType == 'PostaKutusu')"
                                    v-bind="attrs" v-on="on" class="nv-alias">
                                <span class="nv-alias__icon"><v-icon>mdi-check</v-icon></span><span class="nv-alias__label">PK</span>
                              </span>
                              <button v-else type="button" v-bind="attrs" v-on="on" class="nv-alias nv-alias--add"
                                      @click="createAlias(item, module, 'PK')">
                                <span class="nv-alias__icon"><v-icon>mdi-plus</v-icon></span><span class="nv-alias__label">PK</span>
                              </button>
                            </template>
                            <span class="font-size-sm">
                              {{ item.CompanyAliasResponse.some(x=>x.Type === module.Name && x.AliasType == 'PostaKutusu') ? 'Posta Kutusu Etiketi Tanımlı' : 'Posta Kutusu Etiketi Oluştur' }}
                            </span>
                          </v-tooltip>
                          <v-tooltip bottom>
                            <template v-slot:activator="{ on, attrs }">
                              <span v-if="item.CompanyAliasResponse.some(x=>x.Type === module.Name && x.AliasType == 'GondericiBirim')"
                                    v-bind="attrs" v-on="on" class="nv-alias">
                                <span class="nv-alias__icon"><v-icon>mdi-check</v-icon></span><span class="nv-alias__label">GB</span>
                              </span>
                              <button v-else type="button" v-bind="attrs" v-on="on" class="nv-alias nv-alias--add"
                                      @click="createAlias(item, module, 'GB')">
                                <span class="nv-alias__icon"><v-icon>mdi-plus</v-icon></span><span class="nv-alias__label">GB</span>
                              </button>
                            </template>
                            <span class="font-size-sm">
                              {{ item.CompanyAliasResponse.some(x=>x.Type === module.Name && x.AliasType == 'GondericiBirim') ? 'Gönderici Birim Etiketi Tanımlı' : 'Gönderici Birim Etiketi Oluştur' }}
                            </span>
                          </v-tooltip>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </v-expansion-panel-content>
            </v-expansion-panel>
          </v-expansion-panels>
        </v-col>
      </v-row>
    </div>

    <ProcessUserAccount @createBranch="createBranch" @UpdateCompanyInfo="UpdateCompanyInfo"></ProcessUserAccount>
  </div>
</template>

<script>
import ProcessUserAccount from "@/view/pages/Signing/UserAccount"
import {mapGetters} from "vuex";
import {GET_ACCOUNT, GET_CREATION, GET_HEAD_COMPANY} from "@/core/services/store/profile.module";
import activation from "@/core/services/Activation/action";

export default {
  name: "Dashboard",
  components: {
    ProcessUserAccount
  },
  data() {
    return {
      CompanyInfo: [],
      centerModules: ['EInvoice', 'EArchive', 'EDespatch', 'EMM', 'ESMM', 'EBill', 'EInsurance', 'ECurrency', 'Expense'],
      branchModules: ['EInvoice', 'EDespatch'],
    }
  },
  methods: {
    toastError(error) {
      this.$bvToast.toast(error, {
        toaster: 'b-toaster-bottom-right',
        title: 'Hata',
        variant: 'danger',
        solid: true,
        autoHideDelay: 3000,
        bodyClass: "toastError-body",
        headerClass: "toastError-header",
        toastClass: "toastError-container"
      });
    },
    companyModules(company) {
      return Array.isArray(company.ModuleResponse) ? company.ModuleResponse : []
    },
    ModulesIcon(value) {
      switch (value) {
        case 'EInvoice':
          return 'fa fa-file-contract'
        case 'EArchive':
          return 'fa fa-folder-open'
        case 'EDespatch':
          return 'fas fa-truck-moving'
        case 'ESMM':
          return 'fa fa-briefcase'
        case 'EMM':
          return 'fa fa-tractor'
        case 'EBill':
          return 'fas fa-concierge-bell'
        case 'EInsurance':
          return 'fas fa-shield-alt'
        case 'Expense':
          return 'fas fa-compass'
        case 'ECurrency':
          return 'fas fa-money-bill-alt'
      }
    },
    async createModule(companyInfo) {
      let model = {
        Status: 'Module',
        ID: companyInfo.ID,
        Name: companyInfo.Name,
        BranchName: companyInfo.BranchName,
        TaxOffice: companyInfo.TaxOffice,
        IsThereUser: companyInfo.IsThereUser,
        Address: {
          Address: companyInfo.Address,
          District: companyInfo.District,
          City: companyInfo.City,
          Country: companyInfo.Country,
          PostalCode: companyInfo.PostalCode,
          PhoneNumber: companyInfo.PhoneNumber,
          Fax: companyInfo.Fax,
          Email: companyInfo.Email,
          WebSite: companyInfo.WebSite
        }
      }
      if (companyInfo.BranchName != 'Merkez') {
        await this.HeadCompanyModules('Module', model)
      } else {
        await this.$store.dispatch(GET_CREATION, model)
        this.$router.push("/create")
      }
    },
    async createAlias(companyInfo, module, aliasType) {
      let model = {
        Status: 'Alias',
        ID: companyInfo.ID,
        Name: companyInfo.Name,
        AliasType: aliasType,
        Module: module,
        IsThereUser: companyInfo.IsThereUser
      };
      await this.$store.dispatch(GET_CREATION, model);
      this.$router.push("/create");
    },
    async createBranch() {
      let model = {
        Status: 'Branch'
      }
      await this.HeadCompanyModules('Branch', model)
    },
    async HeadCompanyModules(val, model) {
      let _headCompany = this.getAccount.CompanyResponses.find(({BranchName}) => BranchName == 'Merkez')
      let _headCompanyModules = await activation.GetActiveModules(_headCompany.ID)
      if (_headCompanyModules.status == 200) {
        const modules = _headCompanyModules.data.filter(x => !['EArchive', 'EMM', 'ESMM', 'EBill', 'EInsurance', 'ECurrency', 'Expense'].includes(x.Name))
        await this.$store.dispatch(GET_HEAD_COMPANY, modules)
        if (!modules.length) {
          this.toastError(val == 'Module' ? 'Merkez Firmaya Tanımlı Modül Olmadığı İçin Şubeye Yeni Başvuru Yapılamaz !' : 'Merkez Firmaya Tanımlı Modül Olmadığı İçin Yeni Şube Oluşturulamaz !')
        } else {
          await this.$store.dispatch(GET_CREATION, model)
          this.$router.push("/create")
        }
      } else {
        this.toastError("Merkez Firmaya Ait Modüller Getirilirken Hata.")
      }
    },
    async UpdateCompanyInfo() {
      let certificate = this.getCertificate
      let Info = await activation.AccountInfo(certificate.SerialNumber)
      if (Info.status == 200) {
        this.CompanyInfo = []
        await this.$store.dispatch(GET_ACCOUNT, Info.data)
        this.getAccount.CompanyResponses.forEach((item) => {
          this.CompanyInfo.push(item);
        })
      } else {
        Info.data.Errors ? Info.data.Errors.forEach((error) => {
          this.toastError(error)
        }) : this.toastError("Firma Bilgileri Getirilirken Hata.");
      }
    }
  },
  created() {
    if (this.getAccount.IsExist == true) {
      this.getAccount.CompanyResponses.forEach((item) => {
        this.CompanyInfo.push(item);
      })
    } else {
      this.$router.push("/login", () => {
      });
    }
    document.title = 'Nilvera | Firma Bilgileri'
  },
  computed: {
    ...mapGetters(["getAccount", "getCertificate"])
  }
}
</script>

<style scoped>
.nv-company >>> .v-expansion-panel-header:not(.v-expansion-panel-header--mousedown):focus::before {
  opacity: 0;
}
</style>
